document.addEventListener("DOMContentLoaded", function () {
    handleMultiStepForms();
});


function handleMultiStepForms() {
    const multiStepForms = document.querySelectorAll('.js-multi-step-form');

    if (multiStepForms.length === 0) return;

    multiStepForms.forEach(form => {
        const formSteps = form.querySelectorAll('.form-step');
        let currentStep = 1;
        const totalSteps = formSteps.length;
        const stepIndicatorType = form.dataset.stepIndicator;

        const showStep = (step) => {
            formSteps[step - 1].style.display = 'block';
        };

        const hideStep = (step) => {
            formSteps[step - 1].style.display = 'none';
        };

        const updateStepIndicatorDots = () => {
            form.querySelectorAll('.step-dot').forEach(dot => {
                dot.classList.remove('active');
            });
            form.querySelector(`.step-dot[data-step="${currentStep}"]`).classList.add('active');
        };

        const updateStepIndicatorText = () => {
            form.querySelector('.step-indicator-text').innerText = `Step ${currentStep} of ${totalSteps}`;
        };

        const updateStepIndicator = () => {
            if (stepIndicatorType === 'dots') {
                updateStepIndicatorDots();
                return;
            }
            updateStepIndicatorText();
        };

        const areInputsValid = (step) => {
            const inputs = formSteps[step - 1].querySelectorAll('input, select');
            return Array.from(inputs).every(input => input.checkValidity());
        };

        const triggerHtml5Validation = () => {
            form.querySelector('button[type="submit"]').click();
        };

        const nextStep = () => {
            if (!areInputsValid(currentStep)) {
                triggerHtml5Validation();
                return;
            }
            hideStep(currentStep);
            currentStep++;
            showStep(currentStep);
            updateStepIndicator();
        };

        const prevStep = () => {
            hideStep(currentStep);
            currentStep--;
            showStep(currentStep);
            updateStepIndicator();
        };

        const buttonActions = {
            'next_step': nextStep,
            'previous_step': prevStep
        };

        form.querySelectorAll('button[data-step]').forEach(button => {
            const action = buttonActions[button.name];
            if (action) {
                button.addEventListener('click', action);
            }
        });

        updateStepIndicator();
    });
}

